// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TerritoryChipsFilter-wrapper {
  display: flex;
  flex-direction: row;
}
.TerritoryChipsFilter-wrapper [class^=dist_chipTitle] {
  font-size: 14px;
}
.TerritoryChipsFilter-wrapper [class^=dist_chipContainer] {
  height: 32px;
}
.TerritoryChipsFilter-wrapper .generalFilters {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  column-gap: 8px;
}
.TerritoryChipsFilter-wrapper .aditionalFilters {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  margin-left: 8px;
}
.TerritoryChipsFilter-wrapper .aditionalFilters .verticalLine {
  height: 16px;
  width: 1px;
  background-color: var(--color_neutral_500);
}

.AudienceFilterDropdownContent {
  height: 540px;
}
.AudienceFilterDropdownContent .stored-audience-list {
  min-height: 370px;
}`, "",{"version":3,"sources":["webpack://./src/components/TerritoryChipsFilter/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;AACJ;AAEE;EACE,YAAA;AAAJ;AAGE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAFJ;AAII;EACE,YAAA;EACA,UAAA;EACA,0CAAA;AAFN;;AAOA;EACE,aAAA;AAJF;AAME;EACE,iBAAA;AAJJ","sourcesContent":[".TerritoryChipsFilter-wrapper {\n  display: flex;\n  flex-direction: row;\n\n  [class^=\"dist_chipTitle\"] {\n    font-size: 14px;\n  }\n\n  [class^=\"dist_chipContainer\"] {\n    height: 32px;\n  }\n\n  .generalFilters {\n    margin-left: auto;\n    display: flex;\n    flex-direction: row;\n    column-gap: 8px;\n  }\n\n  .aditionalFilters {\n    display: flex;\n    flex-direction: row;\n    column-gap: 8px;\n    align-items: center;\n    margin-left: 8px;\n\n    .verticalLine {\n      height: 16px;\n      width: 1px;\n      background-color: var(--color_neutral_500);\n    }\n  }\n}\n\n.AudienceFilterDropdownContent {\n  height: 540px;\n\n  .stored-audience-list {\n    min-height: 370px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
